import details from './details';

export default {
    details
};